import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.handleClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick)
  }

  handleClick = (event) => {
    // Ignore clicks on interactive elements
    if (event.target.closest("a, button, input, textarea, select, label")) {
      return
    }

    const row = event.target.closest("tr[data-href]")

    if (!row) return

    const url = row.dataset.href

    // Support modifier keys (open in new tab, etc.)
    if (event.metaKey || event.ctrlKey) {
      window.open(url, "_blank")
      return
    }

    // Let Turbo handle the navigation
    visit(url)
  }
}